export default __webpack_public_path__ + "static/media/criminal-backgroundchecks.34db84fe.webp";